import PLANS_PATH from '../../constants/path'
import getCurrentReduxSelector from '../../../redux/selectors/get-current'

const getStartedPlanSelect = getCurrentReduxSelector(
  PLANS_PATH.DATA,
  PLANS_PATH.STARTED
)

export default getStartedPlanSelect
